import React from "react";
import { useState, useEffect } from "react";
import { Form, Button, Col, Row, Container, Modal } from "react-bootstrap";
import {
  saveImageToFirebaseStorage,
  utilCreatePlatilloMenu,
  utilUpdatePlatilloMenu,
  utilDeletePlatilloMenu,
  utilGetInventario,
  utilGetCollectionFilterReference,
  utilCreateInventario,
} from "../../../../util/UtilsFirebase";
import Switch from "react-switch";
import { useAuthContext } from "../../../../hooks/useAuthContext";
import "./PlatilloModal.css";
import { Rows } from "./Rows";
import { RowsCat } from "./RowsCat";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
const PlatilloModal = ({
  menu,
  showPlatillo,
  mod,
  ingredientes,
  agregados,
  itemPlatillo,
  handleClosePlatillo,
  datacategorias,
}) => {
  const [initialPlatilloState] = useState({
    img: null,
    name: "",
    active: true,
    description: "", // Agregado para la descripción
    ncosto1: "", // Agregado para los costos
    costo1: "",
    puntos1: "0",
    ncosto2: "",
    costo2: "",
    puntos2: "0",
    ncosto3: "",
    costo3: "",
    puntos3: "0",
    ingredientes: "0",
    show: true, // Agregado para los switches
    available: true,
  });
  const [ingredientenuevo] = useState({
    ingrediente: null,
    cantidad: 0,
  });
  const { register } = useAuthContext();
  const [image, setImage] = useState(null);
  const [indexCat, setIndexCat] = useState(0);
  const [ingredientesPlatillo, setIngredientesPlatillo] = useState([]);
  const [imageUrl, setImageUrl] = useState(null);
  const [showIngredientes, setShowIngredientes] = useState(false);
  const [showObli, setShowObli] = useState(false);
  const [platillo, setPlatillo] = useState(initialPlatilloState);
  const [isDelete, setIsDelete] = useState(false);
  const [categorias, setCategorias] = useState([]);
  const [categoriaSelected, setcategoriaSelected] = useState(null);
  const [productos, setProductos] = useState([]);
  const [rowsI, setRowsI] = useState([]);
  const [categoriasPers, setCategoriasPers] = useState([]);
  const [agregadosPers, setAgregadosPers] = useState([]);
  const [ingredientesCategoria, setIngredientesCategoria] = useState([]);
  const [agregadosCategoria, setAgregadosCategoria] = useState([]);
  const [agregadosPlatillo, setAgregadosPlatillo] = useState([]);

  useEffect(() => {
    async function getInventario() {
      const fetchOrders = await utilGetCollectionFilterReference(
        "inventario",
        "registro",
        "==",
        register.id,
        "registro"
      );
      if (fetchOrders.length !== 0) {
        const invent = await utilGetInventario(fetchOrders[0].id);
        setProductos(invent.productos);
      } else {
        const invent = {
          registro: null,
        };
        const inventarioid = await utilCreateInventario(invent, register.id);
        const inventa = await utilGetInventario(inventarioid);
        setProductos(inventa.productos);
      }
    }
    if (showPlatillo) {
      console.log("EntroPlatillo");
      setCategorias(datacategorias);
      if (mod) {
        getInventario();
        if (itemPlatillo) {
          setPlatillo(itemPlatillo);
          setImageUrl(itemPlatillo.img);
          if (itemPlatillo.receta != null) {
            setRowsI(itemPlatillo.receta);
          } else {
            setRowsI([]);
          }
          if (itemPlatillo.categoriasPers) {
            setCategoriasPers(itemPlatillo.categoriasPers);
          } else {
            setCategoriasPers([]);
          }
          if (itemPlatillo.agregadosPers) {
            setAgregadosPers(itemPlatillo.agregadosPers);
          } else {
            setAgregadosPers([]);
          }
          if (mod === "UPD") {
            setcategoriaSelected(itemPlatillo.categoria.id);
          }
          if (mod === "ADD") {
            setPlatillo(initialPlatilloState);
            setcategoriaSelected(0);
          }

          if (mod === "DLT") {
            setIsDelete(true);
            setcategoriaSelected(itemPlatillo.categoria.id);
          } else {
            setIsDelete(false);
          }
        } else {
          setPlatillo(initialPlatilloState);
          setRowsI([]);
        }
      }
    }
    setShowIngredientes(false);
  }, [
    showPlatillo,
    itemPlatillo,
    mod,
    menu,
    register.id,
    ingredientenuevo,
    initialPlatilloState,
    datacategorias,
  ]);

  const handleChange = (e) => {
    setPlatillo({
      ...platillo,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelectCategoria = (e) => {
    setcategoriaSelected(e.target.value);
  };

  const selectIngrediente = (e) => {
    const ing = [...categoriasPers];
    if (ing[indexCat].lista.includes(e.target.name)) {
      ing[indexCat].lista.splice(ing[indexCat].lista.indexOf(e.target.name), 1);
    } else {
      ing[indexCat].lista.push(e.target.name);
    }
    setCategoriasPers(ing);
  };

  const selectObli = (e) => {
    const ing = [...agregadosPers];
    if (ing[indexCat].lista.includes(e.target.name)) {
      ing[indexCat].lista.splice(ing[indexCat].lista.indexOf(e.target.name), 1);
    } else {
      ing[indexCat].lista.push(e.target.name);
    }
    setAgregadosPers(ing);
  };

  const handleCloseIngredientes = async () => {
    setShowIngredientes(false);
  };

  const handleCloseObli = async () => {
    setShowObli(false);
  };

  const showModalIngredientes = async (index) => {
    setIngredientesCategoria(categoriasPers[index].lista);
    setIndexCat(index);
    let cat = categorias.filter((e) => e.id === categoriaSelected);
    if (cat.length === 0) {
      alert("Seleccione una categoria");
      return;
    }
    let ing = ingredientes.filter(
      (e) =>
        e.categorias.includes(cat[0].name) &&
        categoriasPers.filter((j, indez) => {
          return indez !== index && j.lista.includes(e.id);
        }).length === 0
    );
    setIngredientesPlatillo(ing);
    setShowIngredientes(true);
  };

  const showModalObli = async (index) => {
    setAgregadosCategoria(agregadosPers[index].lista);
    setIndexCat(index);
    let cat = categorias.filter((e) => e.id === categoriaSelected);
    if (cat.length === 0) {
      alert("Seleccione una categoria");
      return;
    }
    let ing = agregados.filter(
      (e) =>
        e.categorias.includes(cat[0].name) &&
        agregadosPers.filter((j, indez) => {
          return indez !== index && j.lista.includes(e.id);
        }).length === 0
    );
    setAgregadosPlatillo(ing);
    setShowObli(true);
  };

  const handleChangeSwitchAval = (e) => {
    if (e !== undefined) {
      setPlatillo({
        ...platillo,
        available: e,
      });
    }
  };

  const removeCat = (index) => {
    const copyRows = [...categoriasPers];
    copyRows.splice(index, 1);
    setCategoriasPers(copyRows);
  };

  const removeObli = (index) => {
    const copyRows = [...agregadosPers];
    copyRows.splice(index, 1);
    setAgregadosPers(copyRows);
  };

  const agregarCategoria = () => {
    let copy = [...categoriasPers];
    copy.push({
      nombre: "",
      ingredientes: 0,
      especificos: false,
      lista: [],
      precios: {},
    });
    setCategoriasPers(copy);
  };

  const agregarObli = () => {
    let copy = [...agregadosPers];
    copy.push({
      nombre: "",
      ingredientes: 0,
      especificos: false,
      lista: [],
      precios: {},
    });
    setAgregadosPers(copy);
  };

  const handleChangeSwitchShow = (e) => {
    if (e !== undefined) {
      setPlatillo({
        ...platillo,
        show: e,
      });
    }
  };

  const handleChangeSwitchPer = (e) => {
    if (e !== undefined) {
      setPlatillo({
        ...platillo,
        personalizable: e,
      });
    }
  };

  const handleChangeSwitchObli = (e) => {
    if (e !== undefined) {
      setPlatillo({
        ...platillo,
        agregadosObligatorios: e,
      });
    }
  };

  // const handleChangeSwitchEsp = (e) => {
  //   if (e !== undefined) {
  //     setPlatillo({
  //       ...platillo,
  //       especificos: e,
  //     });
  //   }
  // };

  const handleOnChangeCat = (index, name, value) => {
    const copyRows = [...categoriasPers];
    copyRows[index] = {
      ...copyRows[index],
      [name]: value,
    };
    setCategoriasPers(copyRows);
  };

  const handleOnChangeObli = (index, name, value) => {
    const copyRows = [...agregadosPers];
    copyRows[index] = {
      ...copyRows[index],
      [name]: value,
    };
    setAgregadosPers(copyRows);
  };

  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      const selectedImage = e.target.files[0];

      // Read the image file and create a preview URL
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(selectedImage);
        setImageUrl(reader.result);
      };
      reader.readAsDataURL(selectedImage);
    }
  };

  const handleCloseLocal = async () => {
    //setPlatillo(null);
    setImageUrl(null);
    setImage(null);
    setCategorias([]);
    setcategoriaSelected(0);
    setRowsI([ingredientenuevo]);
    handleClosePlatillo();
  };

  const handlePreciosCategoria = (id) => {
    const ing = [...categoriasPers];
    if (!ing[indexCat].precios) {
      ing[indexCat].precios = {};
    }
    if (
      ing[indexCat].precios &&
      Object.keys(ing[indexCat].precios).includes(id)
    ) {
      delete ing[indexCat].precios[id];
    } else {
      ing[indexCat].precios[id] = 0;
    }
    setCategoriasPers(ing);
  };

  const handleCantidadCategoria = (id) => {
    const ing = [...categoriasPers];
    if (!ing[indexCat].cantidad) {
      ing[indexCat].cantidad = {};
    }
    if (
      ing[indexCat].cantidad &&
      Object.keys(ing[indexCat].cantidad).includes(id)
    ) {
      delete ing[indexCat].cantidad[id];
    } else {
      ing[indexCat].cantidad[id] = 0;
    }
    setCategoriasPers(ing);
  };

  const handlePreciosObli = (id) => {
    const ing = [...agregadosPers];
    if (!ing[indexCat].precios) {
      ing[indexCat].precios = {};
    }
    if (
      ing[indexCat].precios &&
      Object.keys(ing[indexCat].precios).includes(id)
    ) {
      delete ing[indexCat].precios[id];
    } else {
      ing[indexCat].precios[id] = 0;
    }
    setAgregadosPers(ing);
  };

  const savePlatillo = async () => {
    let downloadURL = "";
    let alerta = 0;
    categoriasPers.forEach((e) => {
      if (alerta === 0 && e.nombre === "") {
        alert("Ingrese el nombre para todas las categorias.");
        alerta++;
      }
      if (alerta === 0 && parseInt(e.ingredientes) <= 0) {
        alert("Ingrese el numero de ingredientes para todas las categorias.");
        alerta++;
      }
      if (alerta === 0 && e.lista.length === 0) {
        alert(
          "Las categorias deben contener al menos un ingrediente para mostrar."
        );
        alerta++;
      }
    });
    agregadosPers.forEach((e) => {
      if (alerta === 0 && e.nombre === "") {
        alert("Ingrese el nombre para todas las categorias.");
        alerta++;
      }
      if (alerta === 0 && parseInt(e.ingredientes) <= 0) {
        alert("Ingrese el numero de añadidos para todas las categorias.");
        alerta++;
      }
      if (alerta === 0 && e.lista.length === 0) {
        alert(
          "Las categorias deben contener al menos un añadido para mostrar."
        );
        alerta++;
      }
    });
    if (alerta > 0) {
      return;
    }
    if (mod === "ADD") {
      const btn = document.getElementById("BtnGuardar");
      btn.disabled = true;
      if (platillo.name === "") {
        alert("El platillo requiere un nombre");
        btn.disabled = false;
        return;
      }

      if (categoriaSelected === 0) {
        alert("Seleccione una categoria");
        btn.disabled = false;
        return;
      }

      let ingredienteIncompleto = false;

      rowsI.forEach((element) => {
        if (element.ingrediente == null) {
          alert("Seleccione todos los ingredientes");
          btn.disabled = false;
          ingredienteIncompleto = true;
        }
        if (element.cantidad === 0) {
          alert("Coloque una cantidad para todos los ingredientes");
          btn.disabled = false;
          ingredienteIncompleto = true;
        }
      });
      if (ingredienteIncompleto) {
        return;
      }

      //Validate CostosPlatillo
      if (
        (!platillo.ncosto1 || !platillo.costo1) &&
        (!platillo.ncosto2 || !platillo.costo2) &&
        (!platillo.ncosto3 || !platillo.costo3)
      ) {
        alert("Seleccione al menos una Presentacion con Costo");
        btn.disabled = false;
        return;
      }
      platillo.categoriasPers = categoriasPers;
      platillo.agregadosPers = agregadosPers;

      const platilloReg = await utilCreatePlatilloMenu(
        menu.id,
        categoriaSelected,
        platillo
      ); //*

      let path = "";

      path = "truck/" + register.id + "/menu/platillo/" + platilloReg.id + "/";

      if (image) {
        downloadURL = await saveImageToFirebaseStorage(path, image);
      }
      if (downloadURL) {
        setImageUrl(downloadURL);
        platilloReg.img = downloadURL;
      } else {
        setImageUrl(
          "https://firebasestorage.googleapis.com/v0/b/rap-dis.appspot.com/o/NoDisponible.png?alt=media&token=a7fd0957-58f8-4f23-9351-d3393fcfe29c"
        );
        platilloReg.img =
          "https://firebasestorage.googleapis.com/v0/b/rap-dis.appspot.com/o/NoDisponible.png?alt=media&token=a7fd0957-58f8-4f23-9351-d3393fcfe29c";
      }

      platilloReg.receta = rowsI;

      utilUpdatePlatilloMenu(menu.id, categoriaSelected, platilloReg); //**

      //setPlatillo(null);
      setImage(null);
      setImageUrl(null);
      setCategorias([]);
      setcategoriaSelected(0);
      setRowsI([ingredientenuevo]);
      handleClosePlatillo();
    }

    if (mod === "UPD") {
      //Validate CostosPlatillo
      if (image) {
        let path = "";

        //path = "truck/" + register.id +"/menu/platillo/";

        path = "truck/" + register.id + "/menu/platillo/" + platillo.id + "/";

        downloadURL = await saveImageToFirebaseStorage(path, image);

        if (downloadURL) {
          setImageUrl(downloadURL);
        }

        platillo.img = downloadURL;
      }

      platillo.receta = rowsI;
      platillo.categoriasPers = categoriasPers;
      platillo.agregadosPers = agregadosPers;
      utilUpdatePlatilloMenu(menu.id, categoriaSelected, platillo); //**

      //setPlatillo(null);
      setImage(null);
      setImageUrl(null);
      setCategorias([]);
      setcategoriaSelected(0);
      setRowsI([ingredientenuevo]);
      handleClosePlatillo();
    }

    if (mod === "DLT") {
      utilDeletePlatilloMenu(menu.id, platillo);
      setImage(null);
      setImageUrl(null);
      setCategorias([]);
      setcategoriaSelected(0);
      setRowsI([ingredientenuevo]);
      handleClosePlatillo();

      // Esta linea unicamente la utilizo para pruebas e identificar el id del menu relacionado al platillo que se esta eliminado.
      //alert('Menu ID:' + menu.id)
      //alert('Platillo ID:' + platillo.id)
    }
  };

  const handleOnChange = (index, name, value) => {
    const copyRows = [...rowsI];
    copyRows[index] = {
      ...copyRows[index],
      [name]: value,
    };
    setRowsI(copyRows);
  };

  const handleOnAdd = () => {
    rowsI.forEach((element) => {
      if (element.ingrediente) {
      }
    });
    if (rowsI.length < productos.length) {
      setRowsI(rowsI.concat(ingredientenuevo));
    } else {
      alert("No cuentas con mas ingredientes");
    }
  };

  const handleOnRemove = (index) => {
    const copyRows = [...rowsI];
    copyRows.splice(index, 1);
    setRowsI(copyRows);
  };

  return (
    <>
      <Modal show={showPlatillo} onHide={handleClosePlatillo} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {mod && mod === "ADD" ? "AGREGAR" : ""}{" "}
            {mod && mod === "UPD" ? "MODIFICAR" : ""}{" "}
            {mod && mod === "DLT" ? "ELIMINAR" : ""} PLATILLO
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col>
                <Form>
                  {mod && mod === "DLT" ? (
                    <Row>
                      <Col md={12}>
                        <label htmlFor="">
                          ¿Esta seguro de borrar el Platillo?
                        </label>
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}

                  <Row>
                    <Col md={6}>
                      <Form.Group controlId="razonSocial">
                        <Form.Label>Nombre platillo:</Form.Label>
                        <Form.Control
                          disabled={isDelete}
                          onChange={handleChange}
                          value={platillo?.name}
                          name="name"
                          required
                          type="text"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="categoria">
                        <Form.Label>Categoria:</Form.Label>
                        <select
                          disabled={isDelete}
                          value={categoriaSelected}
                          onChange={handleSelectCategoria}
                        >
                          <option value="">Seleccionar</option>
                          {categorias.map((opcion) => (
                            <option key={opcion.id} value={opcion.id}>
                              {opcion.name}
                            </option>
                          ))}
                        </select>
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group controlId="description">
                        <Form.Label>Descripcion:</Form.Label>
                        <textarea
                          disabled={isDelete}
                          onChange={handleChange}
                          value={platillo?.description}
                          name="description"
                          required
                          cols="1"
                          rows="1"
                        >
                          {platillo?.description}
                        </textarea>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <div className="center">
                        <label htmlFor="personalizable" className="mrg-lblshow">
                          Platillo personalizable
                        </label>
                        <Switch
                          id="personalizable"
                          disabled={isDelete}
                          onChange={handleChangeSwitchPer}
                          checked={platillo?.personalizable}
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="center">
                        <label
                          htmlFor="Epecificos"
                          className="mrg-lblshow"
                        ></label>
                        <Button
                          disabled={!platillo?.personalizable}
                          onClick={agregarCategoria}
                        >
                          Añadir categoria <FontAwesomeIcon icon={faPlus} />
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  {categoriasPers.map((row, index) => (
                    <RowsCat
                      {...row}
                      index={index}
                      enabled={!platillo.personalizable}
                      OnRemove={removeCat}
                      OnChange={handleOnChangeCat}
                      OnSelect={showModalIngredientes}
                    />
                  ))}
                  <hr />
                  <Row>
                    <Col md={6}>
                      <div className="center">
                        <label
                          htmlFor="agregadosObligatorios"
                          className="mrg-lblshow"
                        >
                          Añadidos perzonalizables
                        </label>
                        <Switch
                          id="agregadosObligatorios"
                          disabled={isDelete}
                          onChange={handleChangeSwitchObli}
                          checked={platillo?.agregadosObligatorios}
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="center">
                        <label
                          htmlFor="Epecificos"
                          className="mrg-lblshow"
                        ></label>
                        <Button
                          disabled={!platillo?.agregadosObligatorios}
                          onClick={agregarObli}
                        >
                          Añadir categoria <FontAwesomeIcon icon={faPlus} />
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  {agregadosPers.map((row, index) => (
                    <RowsCat
                      {...row}
                      index={index}
                      enabled={!platillo.agregadosObligatorios}
                      OnRemove={removeObli}
                      OnChange={handleOnChangeObli}
                      OnSelect={showModalObli}
                    />
                  ))}
                  {mod !== "UPD" ? (
                    <div>
                      <hr />
                      Receta
                      <div id="Ingredientes">
                        <Row>
                          {rowsI.map((row, index) => (
                            <Rows
                              {...row}
                              onChange={(name, value) =>
                                handleOnChange(index, name, value)
                              }
                              onRemove={() => handleOnRemove(index)}
                              key={index}
                              productos={productos}
                              isDelete={isDelete}
                              cantidad={row.cantidad}
                              ingrediente={row.ingrediente}
                              mod={mod}
                            />
                          ))}
                        </Row>
                        {mod !== "DLT" ? (
                          <Button onClick={handleOnAdd}>Agregar</Button>
                        ) : (
                          ""
                        )}
                      </div>
                      <br />
                      <Row>
                        <hr />
                        <label htmlFor="">Costos</label>
                        <Col md={4} className="border-end">
                          <Form.Group controlId="razonSocial">
                            Nombre de la presentacion
                            <Form.Control
                              placeholder="Nombre presentacion 1"
                              className="mrg-costos"
                              disabled={isDelete}
                              onChange={handleChange}
                              value={platillo?.ncosto1}
                              name="ncosto1"
                              required
                              type="text"
                            />
                            Precio
                            <Form.Control
                              placeholder="0.00"
                              className="mrg-costos"
                              disabled={isDelete}
                              onChange={handleChange}
                              value={platillo?.costo1}
                              name="costo1"
                              required
                              type="number"
                            />
                            Puntos
                            <Form.Control
                              placeholder="0"
                              className="mrg-costos"
                              disabled={isDelete}
                              onChange={handleChange}
                              value={platillo?.puntos1}
                              name="puntos1"
                              required
                              type="number"
                            />
                          </Form.Group>
                        </Col>
                        <Col md={4} className="border-end">
                          <Form.Group controlId="razonSocial">
                            Nombre de la presentacion
                            <Form.Control
                              placeholder="Nombre presentacion 2"
                              className="mrg-costos"
                              disabled={isDelete}
                              onChange={handleChange}
                              value={platillo?.ncosto2}
                              name="ncosto2"
                              required
                              type="text"
                            />
                            Precio
                            <Form.Control
                              placeholder="0.00"
                              className="mrg-costos"
                              disabled={isDelete}
                              onChange={handleChange}
                              value={platillo?.costo2}
                              name="costo2"
                              required
                              type="number"
                            />
                            Puntos
                            <Form.Control
                              placeholder="0"
                              className="mrg-costos"
                              disabled={isDelete}
                              onChange={handleChange}
                              value={platillo?.puntos2}
                              name="puntos2"
                              required
                              type="number"
                            />
                          </Form.Group>
                        </Col>
                        <Col md={4} className="border-end">
                          <Form.Group controlId="razonSocial">
                            Nombre de la presentacion
                            <Form.Control
                              placeholder="Nombre presentacion 3"
                              className="mrg-costos"
                              disabled={isDelete}
                              onChange={handleChange}
                              value={platillo?.ncosto3}
                              name="ncosto3"
                              required
                              type="text"
                            />
                            Precio
                            <Form.Control
                              placeholder="0.00"
                              className="mrg-costos"
                              disabled={isDelete}
                              onChange={handleChange}
                              value={platillo?.costo3}
                              name="costo3"
                              required
                              type="number"
                            />
                            Puntos
                            <Form.Control
                              placeholder="0"
                              className="mrg-costos"
                              disabled={isDelete}
                              onChange={handleChange}
                              value={platillo?.puntos3}
                              name="puntos3"
                              required
                              type="number"
                            />
                          </Form.Group>
                        </Col>
                        <hr />
                      </Row>
                    </div>
                  ) : (
                    <br />
                  )}
                  <Row>
                    <Col md={6}>
                      <div className="center">
                        <label htmlFor="active" className="mrg-lblshow">
                          MOSTRAR
                        </label>
                        <Switch
                          id="active"
                          disabled={isDelete}
                          onChange={handleChangeSwitchShow}
                          checked={platillo?.show}
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="center">
                        <label htmlFor="active" className="mrg-lblshow">
                          DISPONIBLE
                        </label>
                        <Switch
                          id="active"
                          disabled={isDelete}
                          onChange={handleChangeSwitchAval}
                          checked={platillo?.available}
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="center-form">
                    <div className=" offset-sm-12 col-sm-12 center">
                      <Form.Group controlId="img">
                        <label>
                          <img
                            alt=""
                            id="logo_img"
                            src={imageUrl}
                            height="92"
                            width="132"
                          />
                          <input
                            id="logoNeg"
                            type="file"
                            disabled={isDelete}
                            style={{ display: "none" }}
                            accept="image/png"
                            multiple={false}
                            onChange={handleImageChange}
                          />
                        </label>
                      </Form.Group>

                      {mod && mod !== "DLT" ? (
                        <label>Click para seleccionar imagen.</label>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </Form>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseLocal}>
            CANCELAR
          </Button>
          <Button
            id="BtnGuardar"
            variant={mod && mod === "DLT" ? "danger" : "primary"}
            onClick={savePlatillo}
          >
            {mod && mod === "DLT" ? "ELIMINAR" : "GUARDAR"}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showIngredientes} size="lg" onHide={handleCloseIngredientes}>
        <Modal.Header closeButton>
          <Modal.Title>Ingredientes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col md={12}>
                <div className="" disabled={mod === "DLT" ? mod : ""}>
                  {ingredientesPlatillo.map((val, index) => (
                    <Row
                      style={{
                        marginTop: "10px",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      key={index}
                    >
                      <Col md={1}>
                        <input
                          style={{
                            marginTop: "10px !important",
                            marginBottom: "0px !important",
                            marginLeft: "0px !important",
                          }}
                          className="form-check-input"
                          type="checkbox"
                          disabled={mod === "DLT" ? mod : ""}
                          name={val.id}
                          checked={
                            ingredientesCategoria.includes(val.id)
                              ? true
                              : false
                          }
                          onChange={(e) => selectIngrediente(e)}
                          id="flexSwitchCheck"
                        />
                      </Col>
                      <Col md={2}>
                        <label
                          className="lblqrdinamico"
                          style={{
                            paddingTop: "10px",
                            paddingLeft: "20px",
                            width: "10px",
                            fontSize: "20px",
                          }}
                        >
                          {val.name}
                        </label>
                      </Col>
                      <Col md={2}>
                        <label
                          className="lblqrdinamico"
                          style={{
                            paddingTop: "10px",
                            paddingLeft: "20px",
                            width: "10px",
                          }}
                        >
                          Costo adicional
                        </label>
                      </Col>
                      <Col md={1}>
                        <input
                          style={{
                            marginTop: "10px !important",
                            marginBottom: "0px !important",
                            marginLeft: "0px !important",
                          }}
                          className="form-check-input"
                          type="checkbox"
                          disabled={!ingredientesCategoria.includes(val.id)}
                          name={val.id}
                          checked={
                            categoriasPers &&
                            categoriasPers[indexCat] &&
                            categoriasPers[indexCat].precios &&
                            Object.keys(
                              categoriasPers[indexCat].precios
                            ).includes(val.id)
                          }
                          onChange={(e) => handlePreciosCategoria(val.id)}
                          id="flexSwitchCheck"
                        />
                      </Col>
                      <Col md={2}>
                        <input
                          style={{
                            marginTop: "10px !important",
                            marginBottom: "0px !important",
                            marginLeft: "0px !important",
                          }}
                          className="form-input"
                          type="number"
                          value={
                            categoriasPers &&
                            categoriasPers[indexCat] &&
                            categoriasPers[indexCat].precios
                              ? // ? Object.keys(
                                categoriasPers[indexCat].precios[val.id]
                              : // ).includes(val.id)?0:0
                                0
                          }
                          disabled={
                            (categoriasPers &&
                              categoriasPers[indexCat] &&
                              !categoriasPers[indexCat].precios) ||
                            !ingredientesCategoria.includes(val.id) ||
                            (categoriasPers &&
                              categoriasPers[indexCat] &&
                              categoriasPers[indexCat].precios &&
                              !Object.keys(
                                categoriasPers[indexCat].precios
                              ).includes(val.id))
                          }
                          onChange={(e) => {
                            if (
                              e.target.value !== "" &&
                              !isNaN(e.target.value) &&
                              parseFloat(e.target.value) >= 0
                            ) {
                              categoriasPers[indexCat].precios[val.id] =
                                parseFloat(e.target.value);
                              setCategoriasPers([...categoriasPers]);
                            } else {
                              categoriasPers[indexCat].precios[val.id] = 0;
                              setCategoriasPers([...categoriasPers]);
                            }
                          }}
                          name={val.id}
                          id="flexSwitchCheck"
                        />
                      </Col>
                      <Col md={2}>
                        <label
                          className="lblqrdinamico"
                          style={{
                            paddingTop: "10px",
                            paddingLeft: "20px",
                            width: "10px",
                          }}
                        >
                          Cantidad especifica
                        </label>
                      </Col>
                      <Col md={1}>
                        <input
                          style={{
                            marginTop: "10px !important",
                            marginBottom: "0px !important",
                            marginLeft: "0px !important",
                          }}
                          className="form-check-input"
                          type="checkbox"
                          disabled={!ingredientesCategoria.includes(val.id)}
                          name={val.id}
                          checked={
                            categoriasPers &&
                            categoriasPers[indexCat] &&
                            categoriasPers[indexCat].cantidad &&
                            Object.keys(
                              categoriasPers[indexCat].cantidad
                            ).includes(val.id)
                          }
                          onChange={(e) => handleCantidadCategoria(val.id)}
                          id="flexSwitchCheck"
                        />
                      </Col>
                      <Col md={1}>
                        <input
                          style={{
                            marginTop: "10px !important",
                            marginBottom: "0px !important",
                            marginLeft: "0px !important",
                          }}
                          className="form-input"
                          type="number"
                          min={0}
                          value={
                            categoriasPers &&
                            categoriasPers[indexCat] &&
                            categoriasPers[indexCat].cantidad
                              ? // ? Object.keys(
                                categoriasPers[indexCat].cantidad[val.id]
                              : // ).includes(val.id)?0:0
                                0
                          }
                          disabled={
                            (categoriasPers &&
                              categoriasPers[indexCat] &&
                              !categoriasPers[indexCat].cantidad) ||
                            !ingredientesCategoria.includes(val.id) ||
                            (categoriasPers &&
                              categoriasPers[indexCat] &&
                              categoriasPers[indexCat].cantidad &&
                              !Object.keys(
                                categoriasPers[indexCat].cantidad
                              ).includes(val.id))
                          }
                          onChange={(e) => {
                            categoriasPers[indexCat].cantidad[val.id] =
                              parseFloat(e.target.value);
                            setCategoriasPers([...categoriasPers]);
                          }}
                          name={val.id}
                          id="flexSwitchCheck"
                        />
                      </Col>
                    </Row>
                  ))}
                </div>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleCloseIngredientes}>
            CERRAR
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showObli} size="lg" onHide={handleCloseObli}>
        <Modal.Header closeButton>
          <Modal.Title>Añadidos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col md={12}>
                <div className="" disabled={mod === "DLT" ? mod : ""}>
                  {agregadosPlatillo.map((val, index) => (
                    <Row
                      style={{
                        marginTop: "10px",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      key={index}
                    >
                      <Col md={2}>
                        <input
                          style={{
                            marginTop: "10px !important",
                            marginBottom: "0px !important",
                            marginLeft: "0px !important",
                          }}
                          className="form-check-input"
                          type="checkbox"
                          disabled={mod === "DLT" ? mod : ""}
                          name={val.id}
                          checked={
                            agregadosCategoria.includes(val.id) ? true : false
                          }
                          onChange={(e) => selectObli(e)}
                          id="flexSwitchCheck"
                        />
                      </Col>
                      <Col md={4}>
                        <label
                          className="lblqrdinamico"
                          style={{
                            paddingTop: "10px",
                            paddingLeft: "20px",
                            width: "10px",
                            fontSize: "20px",
                          }}
                        >
                          {val.name}
                        </label>
                      </Col>
                      <Col md={2}>
                        <label
                          className="lblqrdinamico"
                          style={{
                            paddingTop: "10px",
                            paddingLeft: "20px",
                            width: "10px",
                          }}
                        >
                          Costo adicional
                        </label>
                      </Col>
                      <Col md={1}>
                        <input
                          style={{
                            marginTop: "10px !important",
                            marginBottom: "0px !important",
                            marginLeft: "0px !important",
                          }}
                          className="form-check-input"
                          type="checkbox"
                          disabled={!agregadosCategoria.includes(val.id)}
                          name={val.id}
                          checked={
                            agregadosPers &&
                            agregadosPers[indexCat] &&
                            agregadosPers[indexCat].precios &&
                            Object.keys(
                              agregadosPers[indexCat].precios
                            ).includes(val.id)
                          }
                          onChange={(e) => handlePreciosObli(val.id)}
                          id="flexSwitchCheck"
                        />
                      </Col>
                      <Col md={3}>
                        <input
                          style={{
                            marginTop: "10px !important",
                            marginBottom: "0px !important",
                            marginLeft: "0px !important",
                          }}
                          className="form-input"
                          type="number"
                          value={
                            agregadosPers &&
                            agregadosPers[indexCat] &&
                            agregadosPers[indexCat].precios
                              ? // ? Object.keys(
                                agregadosPers[indexCat].precios[val.id]
                              : // ).includes(val.id)?0:0
                                0
                          }
                          disabled={
                            (agregadosPers &&
                              agregadosPers[indexCat] &&
                              !agregadosPers[indexCat].precios) ||
                            !agregadosCategoria.includes(val.id) ||
                            (agregadosPers &&
                              agregadosPers[indexCat] &&
                              agregadosPers[indexCat].precios &&
                              !Object.keys(
                                agregadosPers[indexCat].precios
                              ).includes(val.id))
                          }
                          onChange={(e) => {
                            if (
                              e.target.value !== "" &&
                              !isNaN(e.target.value) &&
                              parseFloat(e.target.value) >= 0
                            ) {
                              agregadosPers[indexCat].precios[val.id] =
                                parseFloat(e.target.value);
                              setAgregadosPers([...agregadosPers]);
                            } else {
                              agregadosPers[indexCat].precios[val.id] = 0;
                              setAgregadosPers([...agregadosPers]);
                            }
                          }}
                          name={val.id}
                          id="flexSwitchCheck"
                        />
                      </Col>
                    </Row>
                  ))}
                </div>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleCloseObli}>
            CERRAR
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PlatilloModal;
